import { render, staticRenderFns } from "./BookingRailView.vue?vue&type=template&id=63aaf4d0&scoped=true&"
import script from "./BookingRailView.vue?vue&type=script&lang=js&"
export * from "./BookingRailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aaf4d0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63aaf4d0')) {
      api.createRecord('63aaf4d0', component.options)
    } else {
      api.reload('63aaf4d0', component.options)
    }
    module.hot.accept("./BookingRailView.vue?vue&type=template&id=63aaf4d0&scoped=true&", function () {
      api.rerender('63aaf4d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingRailView.vue"
export default component.exports